import BarChart from "./BarChart";
import LineChart from "./LineChart";
import PieChart from "./PieChart";

const features = [
  {
    name: "Adventure-ready",
    description:
      "The Drawstring Canister is water and tear resistant with durable canvas construction. This bag holds up to the demands of daily use while keeping your snacks secure.",
    component: <BarChart />,
  },
  {
    name: "Minimal and clean",
    description:
      "Everything you need, nothing you don't. This bag has the simple, contemporary design that enables you to tell everyone you know about how essentialism is the only rational way to live life.",
    component: <LineChart />,
  },
];

export default function Head() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-24 sm:py-32 sm:px-2 lg:px-4">
        <div className="max-w-2xl mx-auto px-4 lg:max-w-none">
          <div className="max-w-3xl">
            <h2 className="font-semibold text-gray-500">Drawstring Canister</h2>
            <p className="mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Use it your way
            </p>
            <p className="mt-4 text-gray-500">
              The Drawstring Canister comes with multiple strap and handle
              options to adapt throughout your day. Shoulder sling it, backpack
              it, or handy carry it.
            </p>
          </div>

          <div className="space-y-16 pt-10 mt-10 border-t border-gray-200 sm:pt-16 sm:mt-16">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center"
              >
                <div className="mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    {feature.name}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {feature.description}
                  </p>
                </div>
                <div className="flex-auto lg:col-span-7 xl:col-span-8">
                  <div className="aspect-w-5 aspect-h-3 rounded-lg bg-gray-50 overflow-hidden">
                    {feature.component}
                  </div>
                </div>
              </div>
            ))}
            <div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center">
              <div className="mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Minimal and clean
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  Everything you need, nothing you don't. This bag has the
                  simple, contemporary design that enables you to tell everyone
                  you know about how essentialism is the only rational way to
                  live life.
                </p>
              </div>
              <div className="flex-auto lg:col-span-7 xl:col-span-8">
                <div className="lg:w-1/2 lg:h-1/2 rounded-lg bg-gray-50 overflow-hidden py-1">
                  <PieChart />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
